module.exports = "<span class=\"current-step\" [innerHTML]=\"stepText\"></span>\n<a class=\"step-back\"\n   [routerLink]=\"stepBackRouterLink\"\n   [queryParams]=\"stepBackRouterLinkQueryParams\"\n>\n    <span class=\"icon icon-angle-left\"></span>\n    <span>{{stepBackLabel}}</span>\n</a>\n\n<h1 [innerHTML]=\"stepTitle\"></h1>\n<p *ngIf=\"stepDescription\" [innerHTML]=\"stepDescription\"></p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/collapsible-panel/panel-header/panel-header.component.html
// module id = oF6q
// module chunks = 5